import { render, staticRenderFns } from "./file-view.vue?vue&type=template&id=24e27478&scoped=true&"
import script from "./file-view.vue?vue&type=script&lang=js&"
export * from "./file-view.vue?vue&type=script&lang=js&"
import style0 from "./file-view.vue?vue&type=style&index=0&id=24e27478&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e27478",
  null
  
)

export default component.exports